import API from "../../Data/Domain/API";
import URL from "../../Data/Domain/URL";
import Storage from "../../Data/Domain/Storage";

export async function getEventsByUser(id) {
  const internal_id = id || new Storage("id").getItem();
  const endpoint = URL.buildUrl(`users/${internal_id}/events`);
  return await new API(endpoint).get();
}

export async function createEvent(eventData) {
  const userId = new Storage("id").getItem();
  const endpoint = URL.buildUrl(`users/${userId}/events`);
  return await new API(endpoint).post(eventData);
}